import React from 'react';
import useReportQueryParams from '../../hooks/use-report-query-params';
import WdtClassroomReport from './Classroom';
import WdtStudentReport from './Student';
import ReportHeader from '../common/ReportHeader';
import { ReportEntityType } from '../../types';

const ENTITY_MAP: { [key in ReportEntityType]?: any } = {
  [ReportEntityType.CLASSROOM]: WdtClassroomReport,
  [ReportEntityType.STUDENT]: WdtStudentReport
};

const WdtReport: React.FC = () => {
  const [{ entityType, entityId }] = useReportQueryParams();
  const EntityReport = ENTITY_MAP[entityType];

  if (!entityId) return null;

  if (!EntityReport) return null;

  return (
    <>
      <ReportHeader />
      <EntityReport />
    </>
  );
};

export default WdtReport;
